import { useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";

const selectBenefits = createSelector(
  (state) => state.shopping || {},
  (state) => state.shoppingSelections || [],
  (shopping, selections) => {
    const {
      benefits,
      pointsAvailable,
      medicalNetChange,
      medicalSubscribers,
      specialtyNetChange,
      manuallyAllowedShopping,
      medicalRequired,
      specialtyRequired,
      subscribersRequired,
    } = shopping;
    const { selectedBenefits, pointsRemaining } = benefits.reduce(
      ({ selectedBenefits, pointsRemaining }, benefit) => {
        const selection = selections.find((s) => s.id === benefit.id);

        if (!!selection) {
          const selectedValue =
            benefit.allowMultiple === "amount"
              ? selection.qty // sometimes qty means amount :shrug:
              : benefit.points * selection.qty;

          selectedBenefits.push({
            ...benefit,
            selectedValue,
            qty: selection.qty,
          });
          pointsRemaining = pointsRemaining - selectedValue;
        }

        return { selectedBenefits, pointsRemaining };
      },
      { selectedBenefits: [], pointsRemaining: pointsAvailable }
    );
    return {
      selections,
      selectedBenefits,
      pointsRemaining,
      medicalNetChange,
      medicalSubscribers,
      specialtyNetChange,
      medicalRequired,
      specialtyRequired,
      subscribersRequired,
      manuallyAllowedShopping,
    };
  }
);

export default function useSelectedBenefits() {
  const {
    selections,
    selectedBenefits,
    pointsRemaining,
    medicalNetChange,
    medicalSubscribers,
    specialtyNetChange,
    medicalRequired,
    specialtyRequired,
    subscribersRequired,
    manuallyAllowedShopping,
  } = useSelector((state) => selectBenefits(state));
  return {
    selections,
    selectedBenefits,
    pointsRemaining,
    medicalNetChange,
    medicalSubscribers,
    specialtyNetChange,
    medicalRequired,
    specialtyRequired,
    subscribersRequired,
    manuallyAllowedShopping,
  };
}
